import "core-js/modules/es.function.name";
import _classCallCheck from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module image/imageresize
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import WidgetResize from '@ckeditor/ckeditor5-widget/src/widgetresize';
import ImageResizeCommand from './imageresize/imageresizecommand';
import '../theme/imageresize.css';
/**
 * The image resize plugin.
 *
 * It adds a possibility to resize each image using handles.
 *
 * @extends module:core/plugin~Plugin
 */

var ImageResize =
/*#__PURE__*/
function (_Plugin) {
  _inherits(ImageResize, _Plugin);

  function ImageResize() {
    _classCallCheck(this, ImageResize);

    return _possibleConstructorReturn(this, _getPrototypeOf(ImageResize).apply(this, arguments));
  }

  _createClass(ImageResize, [{
    key: "init",

    /**
     * @inheritDoc
     */
    value: function init() {
      var editor = this.editor;
      var command = new ImageResizeCommand(editor);

      this._registerSchema();

      this._registerConverters();

      editor.commands.add('imageResize', command);
      editor.editing.downcastDispatcher.on('insert:image', function (evt, data, conversionApi) {
        var widget = conversionApi.mapper.toViewElement(data.item);
        var resizer = editor.plugins.get(WidgetResize).attachTo({
          unit: editor.config.get('image.resizeUnit') || '%',
          modelElement: data.item,
          viewElement: widget,
          downcastWriter: conversionApi.writer,
          getHandleHost: function getHandleHost(domWidgetElement) {
            return domWidgetElement.querySelector('img');
          },
          getResizeHost: function getResizeHost(domWidgetElement) {
            return domWidgetElement;
          },
          // TODO consider other positions.
          isCentered: function isCentered() {
            var imageStyle = data.item.getAttribute('imageStyle');
            return !imageStyle || imageStyle == 'full' || imageStyle == 'alignCenter';
          },
          onCommit: function onCommit(newValue) {
            editor.execute('imageResize', {
              width: newValue
            });
          }
        });
        resizer.on('updateSize', function () {
          if (!widget.hasClass('image_resized')) {
            editor.editing.view.change(function (writer) {
              writer.addClass('image_resized', widget);
            });
          }
        });
        resizer.bind('isEnabled').to(command);
      }, {
        priority: 'low'
      });
    }
    /**
     * @private
     */

  }, {
    key: "_registerSchema",
    value: function _registerSchema() {
      this.editor.model.schema.extend('image', {
        allowAttributes: 'width'
      });
    }
    /**
     * Registers image resize converters.
     *
     * @private
     */

  }, {
    key: "_registerConverters",
    value: function _registerConverters() {
      var editor = this.editor; // Dedicated converter to propagate image's attribute to the img tag.

      editor.conversion.for('downcast').add(function (dispatcher) {
        return dispatcher.on('attribute:width:image', function (evt, data, conversionApi) {
          if (!conversionApi.consumable.consume(data.item, evt.name)) {
            return;
          }

          var viewWriter = conversionApi.writer;
          var figure = conversionApi.mapper.toViewElement(data.item);

          if (data.attributeNewValue !== null) {
            viewWriter.setStyle('width', data.attributeNewValue, figure);
            viewWriter.addClass('image_resized', figure);
          } else {
            viewWriter.removeStyle('width', figure);
            viewWriter.removeClass('image_resized', figure);
          }
        });
      });
      editor.conversion.for('upcast').attributeToAttribute({
        view: {
          name: 'figure',
          styles: {
            width: /.+/
          }
        },
        model: {
          key: 'width',
          value: function value(viewElement) {
            return viewElement.getStyle('width');
          }
        }
      });
    }
  }], [{
    key: "requires",

    /**
     * @inheritDoc
     */
    get: function get() {
      return [WidgetResize];
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "pluginName",
    get: function get() {
      return 'ImageResize';
    }
  }]);

  return ImageResize;
}(Plugin);
/**
 * The available options are `'px'` or `'%'`.
 *
 * Determines the size unit applied to the resized image.
 *
 *		ClassicEditor
 *			.create( editorElement, {
 *				image: {
 *					resizeUnit: 'px'
 *				}
 *			} )
 *			.then( ... )
 *			.catch( ... );
 *
 *
 * This option is used by the {@link module:image/imageresize~ImageResize} feature.
 *
 * @default '%'
 * @member {String} module:image/image~ImageConfig#resizeUnit
 */


export { ImageResize as default };